const initialState = {
  userSections: [],
  allSections: [],
  participantView: {},
  userView: {},
  successMessage: '',
  warningMessage: '',
  successUserChangingMessage: '',
  withServer: true,
  registrationClosed: false
};


export default (state = initialState, action) => {
  switch (action.type) {
    case 'PARSE_GET_USER':
      return {
        ...state,
        userSections: action.data.sectionsUser,
        participantView: action.data.participantView,
        userView: action.data.userView,
        withServer: true,
        registrationClosed: action.data.registrationClosed
      };
    case 'UNAUTHORIZED_USER':
      return {...state, withServer: true, registrationClosed: action.registrationClosed};
    case 'GET_USER_ERROR':
      return {...state, withServer: false};
    case 'SECTIONS_LIST':
      return {...state, allSections: action.sectionsList};
    case 'SUCCESS_CHANGING':
      return {
        ...state,
        successMessage: action.message,
        warningMessage: '',
        userSections: action.userSections
      };
    case 'FAILED_CHANGING':
      return {...state, successMessage: '', warningMessage: action.message};
    case 'USER_LOGOUT':
      return {...state, userView: {}, participantView: {}, userSections: []};
    case 'CLEAR_SECTION_MESSAGES':
      return {...state, successMessage: '', warningMessage: ''};
    case 'SUCCESS_USER_CHANGING':
      return {...state, successUserChangingMessage: action.message};
    case 'CLEAR_PARTICIPANT_MESSAGES':
      return {
        ...state,
        successUserChangingMessage: '',
        successMessage: '',
        warningMessage: ''
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/participant-reducer.js